import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getStyleguideSections = (state: ApplicationState) => {
    return state.toolkit.components.styleguide.sections;
};

export const getHasAllStyleguideSectionsOpen = (state: ApplicationState) => {
    return state.toolkit.components.styleguide.hasAllSectionsOpen;
};

export const getStyleguideSectionById = (state: ApplicationState, id: string) => {
    return getStyleguideSections(state).find(x => x.id === id) || null;
};
